import { call, put, select } from 'redux-saga/effects';
import cirrusClient from '../../../services/api/cirrus-client';
import { showSnackbar } from '../../../state/snackbar/snackbarSlice';
import { selectUserCredentials } from '../../../state/userCredential/userCredentialSlice';
import { fetchMessageSessionAction } from '../fetchMessageSession/action';

export function* updateConversationParticipantsSaga(action) {
    const { messageSessionId, participants } = action.payload;
    console.log("these are the updated participants", participants)
    try {
        const { domain, user } = yield select(selectUserCredentials);
        const response = yield call(cirrusClient.put,
            `/v2/domains/${domain}/users/${user}/messagesessions/${messageSessionId}`,
            { participants }
        );
        console.log('[VERBOSE] This is the response', response)

        if (response.status === 202) {

            // Refresh message sessions after update
            yield put(fetchMessageSessionAction());

            yield put(showSnackbar({
                message: 'Participants updated successfully',
                severity: 'success'
            }));
        }
    } catch (error) {
        console.error('Error updating conversation participants:', error);
        yield put(showSnackbar({
            message: 'Failed to update participants.',
            severity: 'error'
        }));
    }
}